<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑管理员' : '添加管理员'"></el-page-header>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-form-item label="昵称">
				<el-input v-model="item.nick_name" placeholder="请输入昵称"></el-input>
			</el-form-item>
			<el-form-item label="邮箱">
				<el-input v-model="item.email" placeholder="请输入邮箱"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input v-model="item.phone" placeholder="请输入手机号"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名">
				<el-input v-model="item.real_name" placeholder="请输入真实姓名"></el-input>
			</el-form-item>
			<el-form-item label="性别">
				<el-radio v-model="item.sex" label="1">男</el-radio>
				<el-radio v-model="item.sex" label="2">女</el-radio>
			</el-form-item>
			<el-form-item label="状态">
				<el-radio v-model="item.status" label="1">正常</el-radio>
				<el-radio v-model="item.status" label="2">锁定</el-radio>
			</el-form-item>
			<el-form-item label="账号">
				<el-input v-model="item.username" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item label="角色" prop="">
				<el-select clearable v-model="item.role_id" placeholder="请选择角色">
					<el-option :label="val.name" :value="val.id" v-for="(val, key) in roles" :key="key"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="密码" v-if="!this.id">
				<el-input v-model="item.password" placeholder="请输入密码"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				roles:[],
			}
		},
		created() {
			this.loadRoles()
			if (this.id) {
				this.loadItem()
			}
		},
		methods: {
			loadRoles: function () {
				this.axios.get('admin/role/index',{params:{
					}}).then(res => {
					this.isLoad = false
					this.roles = res.data.list
				}).catch(() => {
					this.isLoad = false
				})
			},
			loadItem() {
				this.isLoad = !this.isLoad
				this.axios.get('/admin/user/detail?id=' + this.id, {}).then(res => {
						this.isLoad = false
						this.item = res.data.detail
						this.item.sex = this.item.sex.toString()
						this.item.status = this.item.status.toString()
						this.uid = res.uid
					})
					.catch(() => {
						this.isLoad = false
					})
			},
			goBack() {
				this.$router.back(-1)
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad3
				let url = ''
				if (this.id) {
					this.item.id = this.id
					url = '/admin/user/edit'
					this.axios.put(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				} else {
					url = '/admin/user/add'
					this.axios.post(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				}

			}
		}
	}
</script>
<style>
</style>
